module.exports = __webpack_public_path__ + "static/media/noPhoto.5c6a0b1e.jpeg";